import AudioFileUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AudioFileUpdateRequest";
import AudioFileBaseModel from "@models/audioFileBaseModel";
import MusicAudioTranslationViewModel from "./musicAudioTranslationViewModel";



export default class MusicAudioViewModel extends AudioFileBaseModel {
    id: string = '';
    albumId: number = 0;
    isPaid: boolean = false;
    translations: Array<MusicAudioTranslationViewModel> = [];
    constructor(obj?: Partial<MusicAudioViewModel>) {
        super();
        if (obj) {
            Object.assign(this, obj);
        }
    }
    initLanguages(langs: string[]) {
        this.translations = langs.map(x => new MusicAudioTranslationViewModel({
            langCode: x
        }))
    }
    get displayName(): string {
        const translatedName = (this.translations || [])
            .map(x => (x.name || '').trim())
            .find(x => !!x);
        if (translatedName) {
            return translatedName;
        }
        if (this.audioFile && this.audioFile.name) {
            return this.audioFile.name;
        }
        const url = (this.audioUrl || '').toString().split('?')[0];
        return decodeURIComponent(url.split('/').pop() || '');
    }
    applyDefaultTranslationNames() {
        const defaultName = this.audioFile && this.audioFile.name
            ? this.audioFile.name.replace(/\.[^.]+$/, '')
            : '';
        if (!defaultName) {
            return;
        }
        (this.translations || []).forEach(translation => {
            if (!(translation.name || '').trim()) {
                translation.name = defaultName;
            }
        });
    }
    async ensureAudioFileReady(): Promise<void> {
        await super.ensureAudioFileReady();
    }
    hasNewFile(): boolean {
        return !!this.base64File || !!this.audioFile || !this.id;
    }
    toServerModel(): AudioFileUpdateRequest {
        this.applyDefaultTranslationNames();
        return new AudioFileUpdateRequest({
            AlbumId: this.albumId,
            Base64Content: this.base64File,
            Id: this.id || null,
            IsPaid: this.isPaid,
            Translations: (this.translations || []).map(x=>x.toServerModel())
        })
    }
    clone(): MusicAudioViewModel {
        return new MusicAudioViewModel({
            id: this.id,
            albumId: this.albumId,
            base64File: this.base64File,
            audioUrl: this.audioUrl,
            audioFile: this.audioFile,
            isPaid: this.isPaid,
            translations: this.translations.map(x=>new MusicAudioTranslationViewModel({
                index: x.index,
                langCode: x.langCode,
                name: x.name
            }))
        })
    }
}
